// src/feature-module/pages/NotFound.tsx
import React from 'react';

const NotFound = () => {
  return (
    <div>
      <h1>404 - Página não encontrada</h1>
    </div>
  );
};

export default NotFound;
